import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { PayService } from '../service/pay.service';
import { Router } from '@angular/router';
import { BalanceSyncService } from '../service/security/balance-sync.service';
import { UserSessionService } from '../user-session.service';
import { TranfertFormPrimaire } from '../models/tranfertFormPrimaire';
import { TransfertFormBussiness } from '../models/transfertFormBussiness';
import { TransferApiResponse } from '../models/transferApiResponse';



@Component({
  selector: 'app-transfert',
  templateUrl: './transfert.component.html',
  styleUrls: ['./transfert.component.css'],
  standalone: false
})
export class TransfertComponent implements OnInit {
  transfert: UntypedFormGroup;
  transfertb: UntypedFormGroup;
  email: string;
  firstname: string;
  lastname: string;
  primaryaccountnumber: number;
  primaryaccountSolde: number;
  user: Object;
  isSecuritypin: boolean;
  isSolde: boolean;
  succes: boolean;
  isphone: boolean;
  succesb: boolean;
  emeteur: boolean;
  destinataire: boolean;
  sigle: string;
  typcomte: string;
  typ: number;
  notPermited: boolean = false;
  CNINotConfirm: boolean;
  phoneNotConfirm: boolean;
  isSecure: boolean;
  isSecurep: boolean;
  loader: boolean = false;
  partStep: number = 1;
  proStep: number = 1;
  private readonly transferTaxRateBps: number = 20;

  constructor(
    private userService: PayService,
    public userSessionService: UserSessionService,
    private balanceSyncService: BalanceSyncService,
    private router: Router
  ) { }

  ngOnInit(): void {


    //this.sigle = localStorage.getItem('sigle');
    //this.email = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    //this.firstname = localStorage.getItem('firstName');
    //this.lastname = localStorage.getItem('lastName');
    //this.primaryaccountnumber = localStorage.getItem('primaryaccountnumber');
    //this.primaryaccountSolde =  localStorage.getItem('primaryaccountSolde');

    this.initAfterUserLoaded();
  }
  initAfterUserLoaded() {
    this.primaryaccountnumber = Number(this.userSessionService.getPrimaryAccountNumber() ?? 0);
    this.primaryaccountSolde = Number(this.userSessionService.getPrimaryAccountBalance() ?? 0);
    this.ngOntransert();
    this.ngOntransertBussness();
  }


  /*initUtilisateurInformations() {

    this.userService.getUtilisateursInformations(this.email).subscribe(data => {
      this.primaryaccountnumber = String(data['primaryAccount'].accountNumber);
      this.primaryaccountSolde = data['primaryAccount'].accountBalance;
      this.user = data;

    })
  }*/

  ngOntransert() {
    this.transfert = new UntypedFormGroup(
      {
        numero: new UntypedFormControl('', [Validators.required, Validators.pattern('(^(65)[0-9]{1}[0-9]{6}|^(69|66|67)[0-9]{7} |^[0-9]{9})$')]),
        montan: new UntypedFormControl('', [Validators.required, Validators.pattern("[1-9][0-9]*")]),
        securitypin: new UntypedFormControl('', [Validators.required, Validators.pattern("[0-9]{4,6}$")]),
        motif: new UntypedFormControl('', [])
      })
  }

  ngOntransertBussness() {
    this.transfertb = new UntypedFormGroup(
      {
        baccounte: new UntypedFormControl('', [Validators.required, Validators.pattern("[0-9]{9}|(^B[0-9]{9})$")]),
        baccountd: new UntypedFormControl('', [Validators.required, Validators.pattern('(^B[0-9]{9})$')]),
        montant: new UntypedFormControl('', [Validators.required, Validators.pattern("[1-9][0-9]*")]),
        codepin: new UntypedFormControl('', [Validators.required, Validators.pattern("[0-9]{4,6}$")]),
        motif: new UntypedFormControl('', [])
      })
  }

  isSecurityPin(val: any) {
    const username = this.getCurrentUsername();
    if (!username || !val) { return; }
    this.userService.verifierCodeDeSecurite(val, username).subscribe({
      next: (ok: boolean) => {
        if (ok) {
          this.isSecurep = true;
        } else {
          this.isSecurep = false;
          this.handleBadSecurityPin('securitypin');
        }
      },
      error: () => {
        this.isSecurep = false;
        this.handleBadSecurityPin('securitypin');
      }
    });
  }

  isSecurityPinB(val: any) {
    console.log("**************************************" + val)
    const username = this.getCurrentUsername();
    console.log("**************************************", username)
    if (!username || !val) { return; }
    this.userService.verifierCodeDeSecurite(val, username).subscribe({
      next: (ok: boolean) => {
        if (ok) {
          console.log("*******************************************+");
          this.isSecure = true;
        } else {
          this.isSecure = false;
          this.handleBadSecurityPin('codepin');
        }
      },
      error: () => {
        this.isSecure = false;
        this.handleBadSecurityPin('codepin');
      }
    });
  }

  typchange(val: any) {
    const numVal = Number(val);
    if (numVal == 1) {
      this.typcomte = "Personnel"
      this.typ = numVal;
    }
    else if (numVal == 2) {
      this.typcomte = "professionnel"
      this.typ = numVal;

    }

  }
  comparewithsolde(val) {

    if (Number(this.transfert.get('montan').value) <= this.getCurrentAccountSolde()) {
      window.scroll(0, 0)
    }
    else {
      window.scroll(0, 0)
      this.isSolde = true;
      this.transfert.get('montan').setValue('');
      this.transfert.get('montan').updateValueAndValidity();
      setTimeout(() => {
        this.isSolde = false;

      }, 2000);
    }
  }


  comparewithsoldeb(val) {

    if (Number(this.transfertb.get('montant').value) <= this.getCurrentAccountSolde()) {
      window.scroll(0, 0)
    }
    else {
      window.scroll(0, 0)
      this.isSolde = true;
      this.transfertb.get('montant').setValue('');
      this.transfertb.get('montant').updateValueAndValidity();
      setTimeout(() => {
        this.isSolde = false;

      }, 2000);
    }
  }


  private getCurrentAccountSolde(): number {
    const liveBalance = Number(this.userSessionService.getPrimaryAccountBalance());
    if (!Number.isNaN(liveBalance)) {
      return liveBalance;
    }

    const fallbackBalance = Number(this.primaryaccountSolde);
    return Number.isNaN(fallbackBalance) ? 0 : fallbackBalance;
  }

  private getCurrentUserPrimaryAccountNumber(): number {
    return this.primaryaccountnumber = Number(this.userSessionService.getPrimaryAccountNumber());
  }

  private getCurrentUsername(): string {
    return this.email
      || this.userSessionService.getUser()?.username
      || localStorage.getItem('usernameThatUserIsNowConnect2345789');
  }

  private handleBadSecurityPin(controlName: 'securitypin' | 'codepin') {
    window.scroll(0, 0)
    this.isSecuritypin = true;
    const control = controlName === 'securitypin' ? this.transfert?.get('securitypin') : this.transfertb?.get('codepin');
    control?.setValue("");
    setTimeout(() => {
      this.isSecuritypin = false;
    }, 2000);
  }

  // Stepper navigation for Particulier
  nextPartStep() {
    if (this.partStep === 1 && this.transfert.get('numero')?.invalid) { this.transfert.get('numero')?.markAsTouched(); return; }
    if (this.partStep === 2 && this.transfert.get('securitypin')?.invalid) { this.transfert.get('securitypin')?.markAsTouched(); return; }
    this.partStep = Math.min(3, this.partStep + 1);
  }
  prevPartStep() { this.partStep = Math.max(1, this.partStep - 1); }

  // Stepper navigation for Professionnel
  nextProStep() {
    if (this.proStep === 1) {
      if (!this.typ) { return; }
      this.transfertb.get('baccounte')?.markAsTouched();
      this.transfertb.get('baccountd')?.markAsTouched();
      if (this.transfertb.get('baccounte')?.invalid || this.transfertb.get('baccountd')?.invalid) { return; }
    }
    if (this.proStep === 2) {
      this.transfertb.get('codepin')?.markAsTouched();
      if (this.transfertb.get('codepin')?.invalid) { return; }
    }
    this.proStep = Math.min(3, this.proStep + 1);
  }
  prevProStep() { this.proStep = Math.max(1, this.proStep - 1); }

  envoyer(formdata: TranfertFormPrimaire) {
    const username = this.getCurrentUsername() || '';
    const payload: TranfertFormPrimaire = {
      numero: formdata.numero,
      montan: Number(formdata.montan),
      securitypin: Number(formdata.securitypin),
      motif: formdata.motif,
      username
    };
    console.log(payload)
    if (!this.isSecurep) {
      window.scroll(0, 0);
      this.isSecuritypin = true;
      setTimeout(() => {
        this.isSecuritypin = false;
      }, 4000);
      return;
    }

    this.loader = true;
    this.userService.transfertPrimaire(payload).subscribe({
      next: (data: TransferApiResponse | number) => {
        const response = this.normalizePrimaryTransferResponse(data);
        if (response.code === 'SUCCESS') {
          window.scroll(0, 0)
          this.succes = true;
          this.syncBalances();
          this.transfert.reset();
          this.partStep = 1;
          this.loader = false;
          setTimeout(() => {
            this.succes = false;
          }, 4000);
        }
        else if (response.code === 'DESTINATION_NOT_FOUND') {
          window.scroll(0, 0)
          this.isphone = true;
          setTimeout(() => {
            this.isphone = false;
            this.loader = false;
          }, 4000);
        }
        else if (response.code === 'INSUFFICIENT_FUNDS') {
          window.scroll(0, 0)
          this.isSolde = true;
          setTimeout(() => {
            this.isSolde = false;
            this.loader = false;
          }, 4000);
        }
        else if (response.code === 'CNI_NOT_CONFIRMED') {
          window.scroll(0, 0)
          this.CNINotConfirm = true;
          setTimeout(() => {
            this.CNINotConfirm = false;
            this.loader = false;
            //this.loader = false;
          }, 3000);
        }
        else if (response.code === 'PHONE_NOT_CONFIRMED') {
          window.scroll(0, 0)
          this.phoneNotConfirm = true
          setTimeout(() => {
            this.phoneNotConfirm = false;
            this.loader = false;
            //  this.loader = false;
          }, 3000);
        }
        else {
          this.loader = false;
        }
      },
      error: () => {
        this.loader = false;
      }
    })
  }

  sendToBaccount(formdata) {
    if (this.loader) {
      return;
    }

    if (this.isSecure) {
      this.loader = true;
      const username = this.getCurrentUsername() || '';
      const payload: TransfertFormBussiness = {
        baccounte: formdata?.baccounte,
        baccountd: formdata?.baccountd,
        montant: Number(formdata?.montant),
        codepin: Number(formdata?.codepin),
        motifTransfert: formdata?.motif,
        typ: Number(this.typ),
        username
      };
      console.log("*******************************", payload)
      this.userService.transfertBussness(payload).pipe(take(1)).subscribe({
        next: (data: TransferApiResponse | number) => {
        const response = this.normalizeBusinessTransferResponse(data);
        console.log(response);
        if (response.code === 'SUCCESS') {
          window.scroll(0, 0)
          this.succesb = true;
          this.syncBalances();
          this.proStep = 1;
          this.transfertb.reset();
          setTimeout(() => {
            this.succesb = false;
          }, 4000);
        }
        else if (response.code === 'DESTINATION_NOT_FOUND') {
          window.scroll(0, 0)
          this.destinataire = true;
          setTimeout(() => {
            this.destinataire = false;
          }, 4000);
        }
        else if (response.code === 'SOURCE_ACCOUNT_INVALID') {
          window.scroll(0, 0)
          this.emeteur = true;
          setTimeout(() => {
            this.emeteur = false;
          }, 4000);
        }
        else if (response.code === 'OPERATION_NOT_PERMITTED' || response.code === 'INVALID_TRANSFER_TYPE') {
          window.scroll(0, 0)
          this.notPermited = true;
          setTimeout(() => {
            this.notPermited = false;
          }, 4000);
        }
        else if (response.code === 'INSUFFICIENT_FUNDS') {
          window.scroll(0, 0)
          this.isSolde = true;
          setTimeout(() => {
            this.isSolde = false;
          }, 4000);
        }
        else if (response.code === 'CNI_NOT_CONFIRMED') {
          window.scroll(0, 0)
          this.CNINotConfirm = true;
          setTimeout(() => {
            this.CNINotConfirm = false;
            //this.loader = false;
          }, 3000);
        }
        else if (response.code === 'PHONE_NOT_CONFIRMED') {
          window.scroll(0, 0)
          this.phoneNotConfirm = true
          setTimeout(() => {
            this.phoneNotConfirm = false;
            //  this.loader = false;
          }, 3000);
        }
          this.loader = false;
        },
        error: () => {
          this.loader = false;
        }
      })
    }
    else {
      window.scroll(0, 0)
      this.isSecuritypin = true;
      setTimeout(() => {
        this.isSecuritypin = false;
      }, 4000);
    }

  }

  private syncBalances() {
    this.balanceSyncService.syncNow().pipe(take(1)).subscribe({
      next: user => {
        if (user?.primaryAccountBalance !== undefined && user?.primaryAccountBalance !== null) {
          this.primaryaccountSolde = Number(user.primaryAccountBalance);
        }
      },
      error: () => {
        // No-op: la transaction est déjà exécutée côté backend.
      }
    });
  }

  getPartTransferTaxAmount(): number {
    return this.computeTransferTax(this.parseAmount(this.transfert?.get('montan')?.value));
  }

  getPartTransferTotalDebit(): number {
    const amount = this.parseAmount(this.transfert?.get('montan')?.value);
    return amount + this.getPartTransferTaxAmount();
  }

  getProTransferTaxAmount(): number {
    return this.computeTransferTax(this.parseAmount(this.transfertb?.get('montant')?.value));
  }

  getProTransferTotalDebit(): number {
    const amount = this.parseAmount(this.transfertb?.get('montant')?.value);
    return amount + this.getProTransferTaxAmount();
  }

  private parseAmount(value: any): number {
    const amount = Number(value);
    if (!Number.isFinite(amount) || amount <= 0) {
      return 0;
    }
    return amount;
  }

  private computeTransferTax(amount: number): number {
    if (amount <= 0) {
      return 0;
    }
    const tax = (amount * this.transferTaxRateBps) / 10_000;
    return Math.round(tax);
  }

  private normalizePrimaryTransferResponse(data: TransferApiResponse | number): TransferApiResponse {
    if (data && typeof data === 'object' && typeof data.code === 'string') {
      return data;
    }
    const legacyCode = Number(data);
    switch (legacyCode) {
      case 0:
        return { success: true, code: 'SUCCESS', message: 'Transfert effectué avec succès', legacyCode: 0 };
      case -1:
        return { success: false, code: 'DESTINATION_NOT_FOUND', message: 'Destinataire introuvable', legacyCode: -1 };
      case -2:
        return { success: false, code: 'INSUFFICIENT_FUNDS', message: 'Solde insuffisant', legacyCode: -2 };
      case -10:
        return { success: false, code: 'PHONE_NOT_CONFIRMED', message: 'Numéro non confirmé', legacyCode: -10 };
      case -11:
        return { success: false, code: 'CNI_NOT_CONFIRMED', message: 'Identité non confirmée', legacyCode: -11 };
      default:
        return { success: false, code: 'INTERNAL_ERROR', message: 'Erreur interne', legacyCode };
    }
  }

  private normalizeBusinessTransferResponse(data: TransferApiResponse | number): TransferApiResponse {
    if (data && typeof data === 'object' && typeof data.code === 'string') {
      return data;
    }
    const legacyCode = Number(data);
    switch (legacyCode) {
      case 0:
        return { success: true, code: 'SUCCESS', message: 'Transfert effectué avec succès', legacyCode: 0 };
      case -1:
        return { success: false, code: 'DESTINATION_NOT_FOUND', message: 'Compte destinataire introuvable', legacyCode: -1 };
      case -2:
        return { success: false, code: 'SOURCE_ACCOUNT_INVALID', message: 'Compte émetteur invalide', legacyCode: -2 };
      case -3:
        return { success: false, code: 'OPERATION_NOT_PERMITTED', message: 'Opération non autorisée', legacyCode: -3 };
      case -4:
        return { success: false, code: 'INSUFFICIENT_FUNDS', message: 'Solde insuffisant', legacyCode: -4 };
      case -9:
        return { success: false, code: 'INVALID_TRANSFER_TYPE', message: 'Type de transfert invalide', legacyCode: -9 };
      case -10:
        return { success: false, code: 'PHONE_NOT_CONFIRMED', message: 'Numéro non confirmé', legacyCode: -10 };
      case -11:
        return { success: false, code: 'CNI_NOT_CONFIRMED', message: 'Identité non confirmée', legacyCode: -11 };
      default:
        return { success: false, code: 'INTERNAL_ERROR', message: 'Erreur interne', legacyCode };
    }
  }

}
